// Calendar-day helpers. Every date is a `YYYY-MM-DD` string in the client's
// local day; arithmetic goes through UTC midnight (as in the hormones
// feature, whose helpers are re-used here) so a DST change never moves a day.

import { addDays, toMs } from '../../../hormones/core/model/dates';

export {
  DAY_MS,
  MONTH_LONG,
  WEEKDAY_LONG,
  addDays,
  daysBetween,
  fm,
  fmy,
  fr,
  fromMonthIndex,
  localToday,
  longDate,
  monthIndex,
  monthOf,
  toIso,
  toMs,
} from '../../../hormones/core/model/dates';

/** The Monday on or before `iso`. */
export const weekStart = (iso) => addDays(iso, -((new Date(toMs(iso)).getUTCDay() + 6) % 7));

/** The Sunday ending the week that starts on `ws`. */
export const weekEnd = (ws) => addDays(ws, 6);

/** The 7 days of the week that starts on `ws`. */
export const weekDays = (ws) => Array.from({ length: 7 }, (_, i) => addDays(ws, i));

/** First and last day of the month containing `iso`. */
export function monthSpan(iso) {
  const d = new Date(toMs(iso));
  const y = d.getUTCFullYear();
  const m = d.getUTCMonth();
  const p = (n) => String(n).padStart(2, '0');
  const last = new Date(Date.UTC(y, m + 1, 0)).getUTCDate();
  return { start: `${y}-${p(m + 1)}-01`, end: `${y}-${p(m + 1)}-${p(last)}` };
}

/** "Mon" … "Sun" of a date. */
export const weekdayShort = (iso) => ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'][new Date(toMs(iso)).getUTCDay()];

/** Every day from `a` to `b`, inclusive. */
export function eachDay(a, b) {
  const out = [];
  for (let d = a; d <= b; d = addDays(d, 1)) out.push(d);
  return out;
}

/** "08:05" from a local datetime ("2026-10-13T08:05:00" or "2026-10-13 08:05"); '' when it has no time. */
export function hm(datetime) {
  const m = /[T ](\d{1,2}):(\d{2})/.exec(String(datetime ?? ''));
  return m ? `${m[1].padStart(2, '0')}:${m[2]}` : '';
}
